import { Alert, PageHeader, Spinner } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { StressAssessmentList } from '~/features/StressAssessmentList';
import { StressAssessmentScheduleAlert } from '~/features/StressAssessmentScheduleAlert';
import { StressAssessmentScheduleNotificationBanner } from '~/features/StressAssessmentScheduleNotificationBanner';
import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  const { enableStaging } = getEnvFeatureFlag();

  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <PageHeader variant='title' title='ストレスチェック' />
        {enableStaging && (
          <div className={styles.ContactNoticeWrapper}>
            <Alert
              status='info'
              description='実施者（産業医・保健師）向け画面のご利用はお問い合わせください'
              action='お問い合わせ'
              actionLink={ROUTES.CONTACT}
            />
          </div>
        )}
        <div className={styles.ScheduleAlertWrapper}>
          <Suspense fallback={<Spinner />}>
            <StressAssessmentScheduleAlert />
          </Suspense>
        </div>
        <Suspense fallback={<Spinner />}>
          <StressAssessmentList />
        </Suspense>
      </div>
      <div className={styles.BannerWrapper}>
        <Suspense fallback={null}>
          <StressAssessmentScheduleNotificationBanner />
        </Suspense>
      </div>
    </div>
  );
};
